module.exports = __webpack_public_path__ + "img/unlock.348a51ee.svg";